/**
 *强迫下线
 **/

const state = {
  forceDownline: {
    status: false,
    id: '',
    address: '',
  }
}

const getters = {
  forceDownline:state => {
    return state.forceDownline
  }
}

const mutations = {
  setForceDownline(state, data){
    state.forceDownline = data
  },
}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modelState/forceDownline.js